<template>
  <div v-if="canUpgrade" class="upgrade-plan" @click.stop>
    <div v-if="text" class="upgrade-plan__text">{{ text }}</div>
    <UIButtonLink
      :label="`Upgrade your plan`"
      variant="secondary"
      size="xs"
      :to="{ name: ROUTE_NAME.SUBSCRIPTION_PLANS }"
      @click="handleClick"
    />
  </div>
  <div v-else-if="limitText" class="upgrade-plan__limit" @click.stop>
    {{ limitText }}
  </div>
  <div v-else class="upgrade-plan__limit">
    {{ text }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { ROUTE_NAME } from '@/const'

import { useRepositoriesStore } from '@/store/repositories/index'
import { useUserSubscriptionsStore } from '@/store/user/subscriptions'

import { UIButtonLink } from '@ui/buttons'

type Props = {
  text?: string
  limitText?: string
}

type Emits = {
  (e: 'click'): void
}

defineProps<Props>()

const router = useRouter()

const emit = defineEmits<Emits>()

const repositoriesStore = useRepositoriesStore()
const userSubscriptionsStore = useUserSubscriptionsStore()

const isOwner = computed(() => repositoriesStore.isOwner)
const nextPlan = computed(() => userSubscriptionsStore.getNextPlan)

const canUpgrade = computed(() => isOwner.value && nextPlan.value)

const handleClick = () => {
  emit('click')
  router.push({ name: ROUTE_NAME.SUBSCRIPTION })
}
</script>

<style>
.upgrade-plan {
  @apply flex flex-col items-center gap-2;

  &__text {
    @apply flex-auto;
    @apply text-sm sm:text-xs;
    @apply text-gray-700 dark:text-gray-300;
    @apply text-center;
  }

  .ui-button {
    @apply rounded-full;
  }

  &__limit {
    @apply flex flex-col items-center;
    @apply text-sm font-medium;
    @apply text-indigo-500;
  }
}
</style>
